'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { orpc } from '@/lib/api/orpc';
import { queryClient } from '@/lib/queryClient';
import { SsoSection } from '../-components/SsoSection';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/settings/sso/')({
  loader: async () => {
    await queryClient.ensureQueryData(orpc.inboundSso.list.queryOptions({
      input: {}
    }));
  },
  component: SsoSettingsPage
});
function SsoSettingsPage() {
  return <VStack className="gap-8">
      <SsoSection />
    </VStack>;
}